module.exports = __webpack_public_path__ + "img/34.ceb4856a.jpeg";